export const BUTTON_CLICK_SCHEMA =
  'iglu:com.studentbeans/button_click/jsonschema/1-1-0'
export const FILTER_CLICK_SCHEMA =
  'iglu:com.studentbeans/filter_subcategories/jsonschema/1-0-0'

export const TRACKING_ACTIONS = {
  INSTORE_CONSENT_POSITIVE: 'yes sure',
  INSTORE_CONSENT_NEGATIVE: 'no thanks',
  FILTER_INSTORE: 'filter instore',
  FILTER_ONLINE: 'filter online'
}
